import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { DialogRef, DialogService } from '@progress/kendo-angular-dialog';
import { SVGIcon } from '@progress/kendo-svg-icons';
import { BehaviorSubject, takeUntil } from 'rxjs';
import { iepSections } from 'src/app/modules/iep/iep-document/constants/iep-sections';
import { IepSubmitEligibilityRequest } from 'src/app/modules/iep/iep-document/models/iep-eligibilty-models/iep-submit-eligibility.model';
import { IEPService } from 'src/app/modules/iep/iep-document/services/iep.services';
import { PWN_INFO } from 'src/app/modules/pwn/constants/pwn-routes';
import { RoutesConstantService } from 'src/app/services/routes-constant.service';
import { StudentService } from 'src/app/services/student.service';
import { ReviewOrRequestForExtensionDialogComponent } from 'src/app/shared/components/review-or-request-for-extension-dialog/review-or-request-for-extension-dialog.component';
import {
  DELETE_ACTION,
  EDIT,
  EI_CIPS,
  EI_CONSENT_TRANSITION_CONFERENCE,
  EI_CUSTOM_OBSERVATION_ASSESSMENT,
  EI_FEEDING_ASSESSMENT,
  EI_PRESCHOOL_ACCEPTANCE_LETTER,
  EI_VISION_SCREENING_ASSESSMENT,
  FIRST_INDEX,
  LABEL_PRINCIPAL,
  LABEL_SCHOOL_SOCIAL_WORKERS,
  LABEL_TEACHER,
  REQUEST_FOR_ADDITIONAL_REEVALUATION,
  REQUEST_FOR_REEVALUATION,
  REVIEW_REQUEST_FOR_EXTENSION,
  SHARE_PERSONALLY_IDENTIFIABLE_INFORMATION,
  TITLE_PRINCIPAL,
  TITLE_SCHOOL_SOCIAL_WORKERS,
  TITLE_TEACHER
} from 'src/app/shared/constants/grid-actions';
import { MeetingType } from 'src/app/shared/enums/meeting-type';
import { MenuAction } from 'src/app/shared/enums/menu-items';
import { MeetingRole } from 'src/app/shared/interfaces/meeting-role';
import { User } from 'src/app/shared/models/user';
import { AuthStore } from 'src/app/stores/auth.store';
import { PwnType } from '../../../../modules/pwn/shared/enums/pwn-type';
import { AbstractComponent } from '../../abstract-component';
import { viewAction } from 'src/app/shared/constants/form-controls';
import { StudentProfile } from 'src/app/shared/interfaces/student-profile';

@Component({
  selector: 'app-action-cell',
  templateUrl: './action-cell.component.html',
  styleUrls: ['./action-cell.component.scss'],
  standalone: false,
})
export class ActionCellComponent extends AbstractComponent implements OnInit {
  @Input() icon: SVGIcon;
  @Input() actions: string[];
  @Input() module: string;
  @Input() referralSk: string;
  @Input() sharePersonallyIdentifiableInformation: string;
  @Input() studentSk: string;
  @Input() consentSk: string;
  @Input() complianceDate: Date;
  @Input() studentName: string;
  @Input() nycId: string;
  @Input() declassificationId: string;
  @Input() declassificationPwnSk: string;
  @Input() ineligibilitySk: string;
  @Input() ineligibilityPwnSk: string;
  @Input() studentId: string;
  @Input() evaluationDataRoute: string;
  // TODO: Not sure of the datatype. Define and use a proper datatype instead of any
  @Input() documentData: any;
  // TODO: Not sure of the datatype. Define and use a proper datatype instead of any
  @Input() expandedRowData: any[];
  @Input() dueDate: string;
  @Input() evaluationName: string;
  @Input() iepFormSk: string;
  @Input() meetingSk: string;
  @Input() evaluationSk: string;
  @Input() activity: string;
  @Input() preSchoolSummarySk: string;
  @Input() studentGrade: string;
  // TODO: Not sure of the datatype. Define and use a proper datatype instead of any
  @Input() allConsentsSk: any;
  @Input() allOutreachSk: any;
  @Output() refreshGrid: EventEmitter<void> = new EventEmitter<void>();
  // TODO: Not sure of the datatype. Define and use a proper datatype instead of any
  @Output() actionEmitter: EventEmitter<{ documentData: any; action: string }> =
    new EventEmitter<{ documentData: any; action: string }>();
  @Input() pwnType?: number;
  @Input() outreachSk?: string;
  // TODO: Not sure of the datatype. Define and use a proper datatype instead of any
  @Input() iepType: any;
  @Input() isEi: boolean = false;
  @ViewChild('anchor', { read: ElementRef }) public anchor: ElementRef;
  @ViewChild('popup', { read: ElementRef }) public popup: ElementRef;
  @ViewChild('fileInput', { read: ElementRef }) public fileInput: ElementRef;
  @ViewChild('reasonForRequestDialog', { read: TemplateRef<unknown> })
  public reasonForRequestDialog: TemplateRef<unknown>;
  meetingTypeEnum: typeof MeetingType = MeetingType;
  showScheduleMeetingDialog$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  showRequestExtensionDialog$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  showCancelMeetingDialog$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  showStudentRelatedEventsDialog$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  showCloseRequestForReevaluationDialog$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  showCaseClosingEventsDialog$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  showRequestNewDocumentDialog$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  showRequestReUploadDialog$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  showUserEventDialog$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  user: User;
  showActions: boolean = false;
  meetingType: MeetingType;
  meetingRoster: MeetingRole[];
  nycIds: string;
  outreachType: typeof PwnType = PwnType;
  action: string;
  @Input() studentDetails?: StudentProfile;

  constructor(
    private router: Router,
    public studentService: StudentService,
    private routesConstantService: RoutesConstantService,
    public dialogService: DialogService,
    private authStore: AuthStore,
    private iepService: IEPService<IepSubmitEligibilityRequest>
  ) {
    super();
    this.user = this.authStore.UserInfo;
  }

  @HostListener('document:click', ['$event'])
  public documentClick(event: Event): void {
    if (!this.contains(event.target!)) {
      this.toggle(false);
    }
  }

  public toggle(showActions?: boolean): void {
    this.showActions =
      showActions !== undefined ? showActions : !this.showActions;
  }

  ngOnInit(): void {
    this.authStore.UserInfo$.subscribe((userInfo: User) => {
      this.user = userInfo;
    });
    this.user = this.authStore.UserInfo;
  }

  openRequestExtensionDialog(): void {
    this.showRequestExtensionDialog$.next(true);
  }

  closeRequestExtensionDialog(): void {
    this.showRequestExtensionDialog$.next(false);
    this.refreshGrid.emit();
  }

  openScheduleMeetingDialog(): void {
    this.showScheduleMeetingDialog$.next(true);
  }

  closeScheduleMeetingDialog(): void {
    this.showScheduleMeetingDialog$.next(false);
    this.refreshGrid.emit();
  }
  openShowCancelMeetingDialog(): void {
    this.showCancelMeetingDialog$.next(true);
  }

  closeshowCancelMeetingDialog(): void {
    this.showCancelMeetingDialog$.next(false);
    this.refreshGrid.emit();
  }
  openShowCloseRequestForReevaluationDialog(): void {
    this.showCloseRequestForReevaluationDialog$.next(true);
  }

  closeShowRequestForReevaluationDialog(): void {
    this.showCloseRequestForReevaluationDialog$.next(false);
    this.refreshGrid.emit();
  }

  openStudentRelatedEventsDialog(): void {
    this.showStudentRelatedEventsDialog$.next(true);
  }

  closeStudentRelatedEventsDialog(): void {
    this.showStudentRelatedEventsDialog$.next(false);
    this.studentService.refreshGridData(true);
  }

  openCaseClosingEventsDialog(): void {
    this.showCaseClosingEventsDialog$.next(true);
  }

  closeCaseClosingEventsDialog(): void {
    this.showCaseClosingEventsDialog$.next(false);
    this.refreshGrid.emit();
  }

  openRequestNewDocumentDialog(): void {
    this.showRequestNewDocumentDialog$.next(true);
  }

  closeRequestNewDocumentDialog(): void {
    this.showRequestNewDocumentDialog$.next(false);
    this.refreshGrid.emit();
  }

  openRequestReUploadDialog(): void {
    this.showRequestReUploadDialog$.next(true);
  }

  closeRequestReUploadDialog(): void {
    this.showRequestReUploadDialog$.next(false);
    this.refreshGrid.emit();
  }

  openUserEventDialog(): void {
    this.showUserEventDialog$.next(true);
  }

  closeUserEventDialog(): void {
    this.showUserEventDialog$.next(false);
    this.refreshGrid.emit();
  }

  // TODO: Not sure of the datatype. Define and use a proper datatype instead of any
  onSelect(menuItem: any): void {
    switch (this.module.toLowerCase()) {
      case MenuAction.Referral.toLowerCase():
        switch (menuItem.item.text) {
          case MenuAction.View:
            if (
              this.activity === REQUEST_FOR_REEVALUATION ||
              this.activity === REQUEST_FOR_ADDITIONAL_REEVALUATION
            ) {
              this.router.navigate([
                this.routesConstantService.routes.referrals +
                this.referralSk +
                '/' +
                this.nycId +
                '/view/request-for-reevaluation',
              ]);
            } else {
              this.router.navigate(
                [this.routesConstantService.routes.viewReferralsRequestPage],
                { queryParams: { Id: this.referralSk } }
              );
            }
            break;
          case MenuAction.Edit:
            if (
              this.activity === REQUEST_FOR_REEVALUATION ||
              this.activity === REQUEST_FOR_ADDITIONAL_REEVALUATION
            ) {
              this.router.navigate([
                this.routesConstantService.routes.referrals +
                this.referralSk +
                '/' +
                this.nycId +
                '/edit/request-for-reevaluation',
              ]);
            } else {
              this.router.navigate(
                [this.routesConstantService.routes.newReferralsRequestPage],
                { queryParams: { Id: this.referralSk } }
              );
            }
            break;
          case MenuAction.Review:
            if (
              this.activity === REQUEST_FOR_REEVALUATION ||
              this.activity === REQUEST_FOR_ADDITIONAL_REEVALUATION
            ) {
              this.router.navigate([
                this.routesConstantService.routes.referrals +
                this.referralSk +
                '/' +
                this.nycId +
                '/edit/review-request-for-reevaluation',
              ]);
            } else {
              this.router.navigate(
                [this.routesConstantService.routes.viewReferralsRequestPage],
                { queryParams: { Id: this.referralSk } }
              );
            }
            break;
          case MenuAction.SendPwn:
            this.router.navigate(
              [this.routesConstantService.routes.referralsManagePwnPage],
              { queryParams: { Id: this.referralSk } }
            );
            break;
          case MenuAction.SendReevalPwn:
            this.router.navigate([
              this.routesConstantService.routes.referrals +
              this.referralSk +
              '/' +
              this.nycId +
              '/add/pwn/' +
              this.getPwnUrl(this.pwnType),
            ]);
            break;
          case MenuAction.EditReevalPwn:
            this.router.navigate([
              this.routesConstantService.routes.referrals +
              this.referralSk +
              '/' +
              this.nycId +
              '/' +
              this.outreachSk +
              '/edit/pwn/' +
              this.getPwnUrl(this.pwnType),
            ]);
            break;
          case MenuAction.ViewReevalPwn:
            this.router.navigate([
              this.routesConstantService.routes.referrals +
              this.referralSk +
              '/' +
              this.nycId +
              '/' +
              this.outreachSk +
              '/view/pwn/' +
              this.getPwnUrl(this.pwnType),
            ]);
            break;

          case MenuAction.ScheduleShm:
          case MenuAction.ScheduleSocialHistoryMeeting:
            this.nycIds = this?.nycId;
            this.meetingType = this.meetingTypeEnum.SHM;
            this.meetingRoster = [
              {
                label: LABEL_SCHOOL_SOCIAL_WORKERS,
                title: TITLE_SCHOOL_SOCIAL_WORKERS,
                isRequired: true,
                isSticky: true,
                members: [],
              },
            ];
            this.openScheduleMeetingDialog();
            break;
          case MenuAction.RescheduleShm:
          case MenuAction.RescheduleSocialHistoryMeeting:
            this.meetingType = this.meetingTypeEnum.SHM;
            this.nycIds = this?.nycId;
            this.meetingRoster = [
              {
                label: LABEL_SCHOOL_SOCIAL_WORKERS,
                title: TITLE_SCHOOL_SOCIAL_WORKERS,
                isRequired: true,
                isSticky: true,
                members: [],
              },
            ];
            this.openScheduleMeetingDialog();
            break;
          case MenuAction.ScheduleGenEdInterventionMeeting:
            this.meetingType = this.meetingTypeEnum.GenEd;
            this.nycIds = this?.nycId;
            this.meetingRoster = [
              {
                label: LABEL_PRINCIPAL,
                title: TITLE_PRINCIPAL,
                isRequired: true,
                isSticky: true,
                members: [],
              },
              {
                label: LABEL_TEACHER,
                title: TITLE_TEACHER,
                isRequired: true,
                isSticky: true,
                members: [],
              },
            ];
            this.openScheduleMeetingDialog();
            break;
          case MenuAction.RescheduleGenEdInterventionMeeting:
            this.meetingType = this.meetingTypeEnum.GenEd;
            this.nycIds = this?.nycId;
            this.meetingRoster = [
              {
                label: LABEL_PRINCIPAL,
                title: TITLE_PRINCIPAL,
                isRequired: true,
                isSticky: true,
                members: [],
              },
              {
                label: LABEL_TEACHER,
                title: TITLE_TEACHER,
                isRequired: true,
                isSticky: true,
                members: [],
              },
            ];
            this.openScheduleMeetingDialog();
            break;
          case MenuAction.WithdrawParentPrincipalAgreement:
            this.router.navigate(
              [this.routesConstantService.routes.referralsWithdrawPage],
              { queryParams: { Id: this.referralSk } }
            );
            break;
          case MenuAction.Withdraw:
            this.router.navigate(
              [this.routesConstantService.routes.referralsWithdrawPage],
              { queryParams: { Id: this.referralSk } }
            );
            break;
          case MenuAction.RequestToSharePersonallyIdentifiableInformation:
            if (SHARE_PERSONALLY_IDENTIFIABLE_INFORMATION === null) {
              this.router.navigate([
                this.routesConstantService.routes
                  .PersonallyIdentifiableInformation +
                this.nycId +
                '/' +
                SHARE_PERSONALLY_IDENTIFIABLE_INFORMATION +
                '/' +
                this.referralSk +
                '/' +
                'add',
              ]);
            } else {
              this.router.navigate([
                this.routesConstantService.routes
                  .PersonallyIdentifiableInformation +
                this.nycId +
                '/' +
                SHARE_PERSONALLY_IDENTIFIABLE_INFORMATION +
                '/' +
                this.referralSk +
                '/' +
                'edit',
              ]);
            }
            break;
        }
        break;
      case MenuAction.EiTransition.toLowerCase():
        switch (menuItem.item.text) {
          case MenuAction.Edit:
            this.router.navigate([
              this.routesConstantService.routes.eiChildPage,
              'edit',
              this.studentSk,
            ]);
            break;
          case MenuAction.View:
            this.router.navigate([
              this.routesConstantService.routes.eiChildPage,
              'view',
              this.studentSk,
            ]);
            break;
          case MenuAction.RequestReupload:
            this.openRequestReUploadDialog();
            break;
          case MenuAction.RequestNewDocument:
            this.openRequestNewDocumentDialog();
            break;
          case MenuAction.LogOutreachEvent:
            this.openUserEventDialog();
            break;
        }
        break;
      case MenuAction.Evaluations.toLowerCase():
        switch (menuItem.item.text) {
          case MenuAction.EditShp:
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              this.referralSk +
              '/edit/shp',
            ]);
            break;
          case MenuAction.View:
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              this.referralSk +
              '/view/shp',
            ]);
            break;
          case MenuAction.AssessmentPlanning:
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              this.referralSk +
              '/' +
              this.nycId +
              '/edit/assessment-planning',
            ]);
            break;
          case MenuAction.SendPwnAdditionalAssessments:
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              this.referralSk +
              '/' +
              this.nycId +
              '/add/pwn/parent-request-additional-assessments',
            ]);
            break;
          case MenuAction.EditPwnAdditionalAssessments:
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              this.referralSk +
              '/' +
              this.nycId +
              '/' +
              this.outreachSk +
              '/edit/pwn/parent-request-additional-assessments',
            ]);
            break;
          case MenuAction.ReviewPwnAdditionalAssessments:
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              this.referralSk +
              '/' +
              this.nycId +
              '/' +
              this.outreachSk +
              '/edit/pwn/parent-request-additional-assessments',
            ]);
            break;
          case MenuAction.ViewPwnAdditionalAssessments:
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              this.referralSk +
              '/' +
              this.nycId +
              '/' +
              this.outreachSk +
              '/view/pwn/parent-request-additional-assessments',
            ]);
            break;
          case MenuAction.CreatePreschoolSummary:
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              '/' +
              this.nycId +
              '/' +
              this.referralSk +
              '/edit/preschool-summary',
            ]);
            break;
          case MenuAction.ViewPreschoolSummary:
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              '/' +
              this.nycId +
              '/' +
              this.referralSk +
              '/' +
              this.preSchoolSummarySk +
              '/view/preschool-summary',
            ]);
            break;
          case MenuAction.EditPreschoolSummary:
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              '/' +
              this.nycId +
              '/' +
              this.referralSk +
              '/' +
              this.preSchoolSummarySk +
              '/edit/preschool-summary',
            ]);
            break;
          case MenuAction.RescheduleShm:
          case MenuAction.RescheduleSocialHistoryMeeting:
            this.meetingType = this.meetingTypeEnum.SHM;
            this.nycIds = this?.nycId;
            this.meetingRoster = [
              {
                label: LABEL_SCHOOL_SOCIAL_WORKERS,
                title: TITLE_SCHOOL_SOCIAL_WORKERS,
                isRequired: true,
                isSticky: true,
                members: [],
              },
            ];
            this.openScheduleMeetingDialog();
            break;
          case MenuAction.CancelMeetings:
            this.openShowCancelMeetingDialog();
            break;
          case MenuAction.ScheduleMeeting:
            this.meetingType = this.meetingTypeEnum.EVL;
            this.nycIds = this?.nycId;
            this.meetingRoster = [
              {
                label: LABEL_SCHOOL_SOCIAL_WORKERS,
                title: TITLE_SCHOOL_SOCIAL_WORKERS,
                isRequired: true,
                isSticky: true,
                members: [],
              },
            ];
            this.openScheduleMeetingDialog();
            break;
          case MenuAction.RescheduleMeeting:
            this.meetingType = this.meetingTypeEnum.EVL;
            this.nycIds = this?.nycId;
            this.meetingRoster = [
              {
                label: LABEL_SCHOOL_SOCIAL_WORKERS,
                title: TITLE_SCHOOL_SOCIAL_WORKERS,
                isRequired: true,
                isSticky: true,
                members: [],
              },
            ];
            this.openScheduleMeetingDialog();
            break;
          case MenuAction.CloseRequest:
            this.openShowCloseRequestForReevaluationDialog();
            break;
          case MenuAction.CreateFinalNoticeWithdrawalEval:
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              `${this.referralSk}/${this.nycId}` +
              '/add/outreach/final-notice-of-withdrawal',
            ]);
            break;
          case MenuAction.EditFinalNoticeWithdrawalEval:
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              `${this.referralSk}/${this.nycId}/${this.allOutreachSk.finalNoticeofInitialEvalWithdrawalSk}` +
              '/edit/outreach/final-notice-of-withdrawal',
            ]);
            break;
          case MenuAction.ViewFinalNoticeWithdrawalEval:
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              `${this.referralSk}/${this.nycId}/${this.allOutreachSk.finalNoticeofInitialEvalWithdrawalSk}` +
              '/view/outreach/final-notice-of-withdrawal',
            ]);
            break;
        }
        break;
      case MenuAction.EvaluationsNested.toLowerCase():
        switch (menuItem.item.text) {
          case MenuAction.View:
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              this.evaluationSk +
              '/' +
              this.studentId +
              '/view/' +
              this.evaluationDataRoute,
            ]);
            break;
          case MenuAction.Edit:
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              this.evaluationSk +
              '/' +
              this.studentId +
              '/edit/' +
              this.evaluationDataRoute,
            ]);
            break;
          case MenuAction.AssistiveTechnologyAssessment:
            this.router.navigate([
              this.routesConstantService.routes.d75Assessments +
              this.evaluationSk +
              '/' +
              this.studentId +
              '/add/',
            ]);
            break;
          case MenuAction.RequestExtension:
          case MenuAction.ReviewRequestExtension: {
            const dialog: DialogRef = this.dialogService.open({
              content: ReviewOrRequestForExtensionDialogComponent,
            });
            dialog.content.instance.evaluationSk = this.evaluationSk;
            dialog.content.instance.studentId = this.studentId;
            dialog.content.instance.isReview =
              menuItem.item.text === REVIEW_REQUEST_FOR_EXTENSION
                ? true
                : false;

            break;
          }
          case MenuAction.CreateExtensionRequest:
            this.openRequestExtensionDialog();
            break;
          case MenuAction.ReviewExtensionRequest:
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              this.evaluationSk +
              '/' +
              this.studentId +
              '/review/' +
              this.evaluationDataRoute,
            ]);
            break;
          case MenuAction.ViewExtensionRequest:
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              this.evaluationSk +
              '/' +
              this.studentId +
              '/view/' +
              this.evaluationDataRoute,
            ]);
            break;
          case MenuAction.ReviewAssessment:
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              this.evaluationSk +
              '/' +
              this.studentId +
              '/reviewassessment/' +
              this.evaluationDataRoute,
            ]);

            break;
          case MenuAction.ViewAssessment:
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              this.evaluationSk +
              '/' +
              this.studentId +
              '/viewassessment/' +
              this.evaluationDataRoute,
            ]);

            break;
        }
        break;
      case MenuAction.Iep.toLowerCase():
        switch (menuItem.item.text) {
          case MenuAction.CreateIepDocument: {
            const eligibilityRequestdata: IepSubmitEligibilityRequest =
              new IepSubmitEligibilityRequest({
                referralSK: this.referralSk,
                lastModuser: this.user?.username,
              } as IepSubmitEligibilityRequest);
            this.iepService
              .submit(eligibilityRequestdata, iepSections.eligibilty)
              .pipe(takeUntil(this.componentDestroyed))
              //TODO:We need to check datatype for the api endpoints, once added we need to add the datatype to the subscribe method
              .subscribe((data) => {
                if (data) {
                  this.router.navigate([
                    this.routesConstantService.routes.addiepdocument +
                    this?.nycId +
                    '/' +
                    data?.value?.iepFormSK +
                    '/edit/eligibility',
                  ]);
                }
              });
            break;
          }
          case MenuAction.CreateIep: {
            const eligibilityRequestdatas: IepSubmitEligibilityRequest =
              new IepSubmitEligibilityRequest({
                referralSK: this.referralSk,
                lastModuser: this.user?.username,
              } as IepSubmitEligibilityRequest);
            this.iepService
              .submit(eligibilityRequestdatas, iepSections.eligibilty)
              .pipe(takeUntil(this.componentDestroyed))
              //TODO:We need to check datatype for the api endpoints, once added we need to add the datatype to the subscribe method
              .subscribe((data) => {
                if (data) {
                  this.router.navigate([
                    this.routesConstantService.routes.addiepdocument +
                    this?.nycId +
                    '/' +
                    data?.value?.iepFormSK +
                    '/edit/eligibility',
                  ]);
                }
              });
            break;
          }
          case MenuAction.EditIepDocument:
            this.router.navigate([
              this.routesConstantService.routes.addiepdocument +
              this?.nycId +
              '/' +
              this.iepFormSk +
              '/' +
              this.studentGrade +
              '/' +
              this.meetingSk +
              '/edit/eligibility',
            ]);
            break;
          case MenuAction.ViewIepDocument:
            this.router.navigate([
              this.routesConstantService.routes.addiepdocument +
              this?.nycId +
              '/' +
              this.iepFormSk +
              '/' +
              this.studentGrade +
              '/' +
              this.meetingSk +
              '/view/eligibility',
            ]);
            break;
          case MenuAction.CreateAssuranceChecklist:
            this.router.navigate([
              this.routesConstantService.routes.assuranceChecklist +
              this.iepFormSk +
              '/edit',
            ]);
            break;
          case MenuAction.EditAssuranceChecklist:
            this.router.navigate([
              this.routesConstantService.routes.assuranceChecklist +
              this.iepFormSk +
              '/edit',
            ]);
            break;
          case MenuAction.ViewAssuranceChecklist:
            this.router.navigate([
              this.routesConstantService.routes.assuranceChecklist +
              this.iepFormSk +
              '/view',
            ]);
            break;

          case MenuAction.CreateLreForm:
            this.router.navigate([
              this.routesConstantService.routes.addiepdocument +
              'lre' +
              '/' +
              this.nycId +
              '/' +
              this.iepFormSk +
              '/edit',
            ]);
            break;
          case MenuAction.EditLreForm:
            this.router.navigate([
              this.routesConstantService.routes.addiepdocument +
              'lre' +
              '/' +
              this.nycId +
              '/' +
              this.iepFormSk +
              '/edit',
            ]);
            break;
          case MenuAction.ViewLreForm:
            this.router.navigate([
              this.routesConstantService.routes.addiepdocument +
              'lre' +
              '/' +
              this.nycId +
              '/' +
              this.iepFormSk +
              '/view',
            ]);
            break;

          case MenuAction.CreateIneligibilityDocument:
            this.router.navigate([
              this.routesConstantService.routes.ineligibilityDocuments +
              '/' +
              this.nycId +
              '/' +
              this.studentSk +
              '/edit',
            ]);
            break;
          case MenuAction.ViewIneligibility:
            this.router.navigate([
              this.routesConstantService.routes.ineligibilityDocuments +
              '/' +
              this.nycId +
              '/' +
              this.ineligibilitySk +
              '/' +
              this.iepFormSk +
              '/view',
            ]);
            break;
          case MenuAction.CreateWaiverOfIepMeeting:
            this.router.navigate([
              this.routesConstantService.routes.waiverofIepMeeting +
              '/' +
              this.nycId +
              '/' +
              this.iepFormSk +
              '/add',
            ]);
            break;
          case MenuAction.ViewWaiverOfIepMeeting:
            this.router.navigate([
              this.routesConstantService.routes.waiverofIepMeeting +
              '/' +
              this.nycId +
              '/' +
              this.iepFormSk +
              '/' +
              this.consentSk +
              '/view',
            ]);
            break;
          case MenuAction.ViewDeclassification:
            this.router.navigate([
              this.routesConstantService.routes.declassification +
              this.nycId +
              '/' +
              this.declassificationId +
              '/' +
              this.iepFormSk +
              '/view',
            ]);
            break;
          case MenuAction.CreateDeclassification:
            this.router.navigate([
              this.routesConstantService.routes.declassification +
              this.nycId +
              '/' +
              this.iepFormSk +
              '/edit',
            ]);
            break;
          case MenuAction.EditDeclassification:
            this.router.navigate([
              this.routesConstantService.routes.declassification +
              this.nycId +
              '/' +
              this.declassificationId +
              '/' +
              this.iepFormSk +
              '/edit',
            ]);
            break;
          case MenuAction.ScheduleIepMeeting:
            this.meetingType = this.meetingTypeEnum.IEP;
            this.nycIds = this?.nycId;
            this.meetingRoster = [
              {
                label: LABEL_SCHOOL_SOCIAL_WORKERS,
                title: TITLE_SCHOOL_SOCIAL_WORKERS,
                isRequired: true,
                isSticky: true,
                members: [],
              },
            ];
            this.openScheduleMeetingDialog();
            break;
          case MenuAction.RescheduleIepMeeting:
            this.meetingType = this.meetingTypeEnum.IEP;
            this.nycIds = this?.nycId;
            this.meetingRoster = [
              {
                label: LABEL_SCHOOL_SOCIAL_WORKERS,
                title: TITLE_SCHOOL_SOCIAL_WORKERS,
                isRequired: true,
                isSticky: true,
                members: [],
              },
            ];
            this.openScheduleMeetingDialog();
            break;
          case MenuAction.CreateTwelveMonthSchoolYearConsentForm:
            this.router.navigate([
              this.routesConstantService.routes.iepDocumentPage +
              `/${this.nycId}/${this.iepFormSk}/${this.iepType}` +
              '/add/consent/tweleve-month-school-year',
            ]);
            break;
          case MenuAction.EditTwelveMonthSchoolYearConsentForm:
            this.router.navigate([
              this.routesConstantService.routes.iepDocumentPage +
              `/${this.allConsentsSk.twelveMonthConsentSk}/${this.nycId}/${this.iepFormSk}/${this.iepType}` +
              '/edit/consent/tweleve-month-school-year',
            ]);
            break;
          case MenuAction.ViewTwelveMonthSchoolYearConsentForm:
            this.router.navigate([
              this.routesConstantService.routes.iepDocumentPage +
              `/${this.allConsentsSk.twelveMonthConsentSk}/${this.nycId}/${this.iepFormSk}/${this.iepType}` +
              '/view/consent/tweleve-month-school-year',
            ]);
            break;
          case MenuAction.CreateEdBenefitReview:
            this.router.navigate([
              this.routesConstantService.routes.iepDocumentPage +
              `/educational-benefit-review-process/${this.nycId}/${this.iepFormSk}` +
              '/add',
            ]);
            break;
          case MenuAction.EditEdBenefitReview:
            this.router.navigate([
              this.routesConstantService.routes.iepDocumentPage +
              `/educational-benefit-review-process/${this.nycId}/${this.iepFormSk}` +
              '/edit',
            ]);
            break;
          case MenuAction.ViewEdBenefitReview:
            this.router.navigate([
              this.routesConstantService.routes.iepDocumentPage +
              `/educational-benefit-review-process/${this.nycId}/${this.iepFormSk}` +
              '/view',
            ]);
            break;
          case MenuAction.SendPwnNoticeOfRecommendation:
            this.router.navigate([
              this.routesConstantService.routes.iepDocumentPage +
              '/' +
              this.iepFormSk +
              '/' +
              this.nycId +
              '/' +
              this.iepFormSk +
              '/add/pwn/' +
              this.getPwnUrl(this.pwnType),
            ]);
            break;
          case MenuAction.ViewPwnNoticeOfRecommendation:
            this.router.navigate([
              this.routesConstantService.routes.iepDocumentPage +
              '/' +
              this.iepFormSk +
              '/' +
              this.nycId +
              '/' +
              this.iepFormSk +
              '/' +
              this.outreachSk +
              '/view/pwn/' +
              this.getPwnUrl(this.pwnType),
            ]);
            break;
          case MenuAction.EditPwnNoticeOfRecommendation:
            this.router.navigate([
              this.routesConstantService.routes.iepDocumentPage +
              '/' +
              this.iepFormSk +
              '/' +
              this.nycId +
              '/' +
              this.iepFormSk +
              '/' +
              this.outreachSk +
              '/edit/pwn/' +
              this.getPwnUrl(this.pwnType),
            ]);
            break;
          case MenuAction.ViewDeclassificationPwnRecommendation:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.declassificationId}/${this.nycId}/${this.iepFormSk}/${this.declassificationPwnSk}` +
              '/view/pwn/declassification',
            ]);
            break;
          case MenuAction.ViewIneligibilityPwnRecommendation:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.ineligibilitySk}/${this.nycId}/${this.iepFormSk}/${this.ineligibilityPwnSk}` +
              '/view/pwn/initial-eligibility-recommendation-ineligible',
            ]);
            break;
          case MenuAction.EditDeclassificationPwnRecommendation:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.declassificationId}/${this.nycId}/${this.iepFormSk}/${this.declassificationPwnSk}` +
              '/edit/pwn/declassification',
            ]);
            break;
          case MenuAction.EditIneligibilityPwnRecommendation:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.ineligibilitySk}/${this.nycId}/${this.iepFormSk}/${this.ineligibilityPwnSk}` +
              '/edit/pwn/initial-eligibility-recommendation-ineligible',
            ]);
            break;
        }
        break;
      case MenuAction.CbstDashboard.toLowerCase():
        switch (menuItem.item.text) {
          case MenuAction.Review:
            this.router.navigate([
              this.routesConstantService.routes.assuranceChecklist +
              this.iepFormSk +
              '/edit',
            ]);
            break;
          case MenuAction.ViewCentralResponse:
            this.router.navigate([
              this.routesConstantService.routes.assuranceChecklist +
              this.iepFormSk +
              '/view',
            ]);
            break;
          case MenuAction.ViewAssuranceChecklist:
            this.router.navigate([
              this.routesConstantService.routes.assuranceChecklist +
              this.iepFormSk +
              '/view',
            ]);
            break;
          case MenuAction.ViewLre:
            this.router.navigate([
              this.routesConstantService.routes.lre +
              '/' +
              this.iepFormSk +
              '/view',
            ]);
            break;
        }

        break;
      case MenuAction.Placement.toLowerCase():
        switch (menuItem.item.text) {
          // Initial Provision of Services
          case MenuAction.CreateConsentInitialProvisionServices:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.nycId}/${this.iepFormSk}/${this.iepType}` +
              '/add/consent/initial-provision-services',
            ]);
            break;
          case MenuAction.EditConsentInitialProvisionServices:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.allConsentsSk.consentSkInitialProvisionalService}/${this.nycId}/${this.iepFormSk}/${this.iepType}` +
              '/edit/consent/initial-provision-services',
            ]);
            break;
          case MenuAction.ViewConsentInitialProvisionServices:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.allConsentsSk.consentSkInitialProvisionalService}/${this.nycId}/${this.iepFormSk}/${this.iepType}` +
              '/view/consent/initial-provision-services',
            ]);
            break;

          //  Initial Provision of Services/Parentally Placed
          case MenuAction.CreateConsentInitialProvisionServicesParentallyPlaced:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.nycId}/${this.iepFormSk}/${this.iepType}` +
              '/add/consent/initial-provision-services-parentally-placed',
            ]);
            break;
          case MenuAction.EditConsentInitialProvisionServicesParentallyPlaced:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.allConsentsSk.consentSkParentallyPlaced}/${this.nycId}/${this.iepFormSk}/${this.iepType}` +
              '/edit/consent/initial-provision-services-parentally-placed',
            ]);
            break;
          case MenuAction.ViewConsentInitialProvisionServicesParentallyPlaced:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.allConsentsSk.consentSkParentallyPlaced}/${this.nycId}/${this.iepFormSk}/${this.iepType}` +
              '/view/consent/initial-provision-services-parentally-placed',
            ]);
            break;

          //  Services/ Deferred Placement
          case MenuAction.CreateConsentServicesDeferredPlacement:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.nycId}/${this.iepFormSk}/${this.iepType}` +
              '/add/consent/services-deferred-placement',
            ]);
            break;
          case MenuAction.EditConsentServicesDeferredPlacement:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.allConsentsSk.consentSkDeferredPlacement}/${this.nycId}/${this.iepFormSk}/${this.iepType}` +
              '/edit/consent/services-deferred-placement',
            ]);
            break;
          case MenuAction.ViewConsentServicesDeferredPlacement:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.allConsentsSk.consentSkDeferredPlacement}/${this.nycId}/${this.iepFormSk}/${this.iepType}` +
              '/view/consent/services-deferred-placement',
            ]);
            break;

          //  DEP-1
          case MenuAction.CreateConsentDep1:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.nycId}/${this.iepFormSk}/${this.iepType}` +
              '/add/consent/dep',
            ]);
            break;
          case MenuAction.EditConsentDep1:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.allConsentsSk.consentSkDEP1}/${this.nycId}/${this.iepFormSk}/${this.iepType}` +
              '/edit/consent/dep',
            ]);
            break;
          case MenuAction.ViewConsentDep1:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.allConsentsSk.consentSkDEP1}/${this.nycId}/${this.iepFormSk}/${this.iepType}` +
              '/view/consent/dep',
            ]);
            break;

          // Parent Notice of Intent/Parentally Placed
          case MenuAction.CreateConsentParentNoticeIntentParentallyPlaced:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.nycId}/${this.iepFormSk}/${this.iepType}` +
              '/add/consent/parent-notice-of-intent',
            ]);
            break;
          case MenuAction.EditConsentParentNoticeIntentParentallyPlaced:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.allConsentsSk.consentSkParentNoticeofParentallyPlaced}/${this.nycId}/${this.iepFormSk}/${this.iepType}` +
              '/edit/consent/parent-notice-of-intent',
            ]);
            break;
          case MenuAction.ViewConsentParentNoticeIntentParentallyPlaced:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.allConsentsSk.consentSkParentNoticeofParentallyPlaced}/${this.nycId}/${this.iepFormSk}/${this.iepType}` +
              '/view/consent/parent-notice-of-intent',
            ]);
            break;

          //  Share Information/Parentally Placed
          case MenuAction.CreateConsentShareInformationParentallyPlaced:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.nycId}/${this.iepFormSk}/${this.iepType}` +
              '/add/consent/request-to-share-information',
            ]);
            break;
          case MenuAction.EditConsentShareInformationParentallyPlaced:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.allConsentsSk.consentSkShareInformationParentallyPlaced}/${this.nycId}/${this.iepFormSk}/${this.iepType}` +
              '/edit/consent/request-to-share-information',
            ]);
            break;
          case MenuAction.ViewConsentShareInformationParentallyPlaced:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.allConsentsSk.consentSkShareInformationParentallyPlaced}/${this.nycId}/${this.iepFormSk}/${this.iepType}` +
              '/view/consent/request-to-share-information',
            ]);
            break;

          //  Extended School Year Parent Survey
          case MenuAction.CreateConsentExtendedSchoolYearParentSurvey:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.nycId}/${this.iepFormSk}/${this.iepType}` +
              '/add/consent/ESY-survey',
            ]);
            break;
          case MenuAction.EditConsentExtendedSchoolYearParentSurvey:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.allConsentsSk.consentSkESY}/${this.nycId}/${this.iepFormSk}/${this.iepType}` +
              '/edit/consent/ESY-survey',
            ]);
            break;
          case MenuAction.ViewConsentExtendedSchoolYearParentSurvey:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.allConsentsSk.consentSkESY}/${this.nycId}/${this.iepFormSk}/${this.iepType}` +
              '/view/consent/ESY-survey',
            ]);
            break;

          //  C7P
          case MenuAction.CreateConsentC7P:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.nycId}/${this.iepFormSk}/${this.iepType}` +
              '/add/consent/final-notice-of-recommendation',
            ]);
            break;
          case MenuAction.EditConsentC7P:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.allConsentsSk.consentSkC7P}/${this.nycId}/${this.iepFormSk}/${this.iepType}` +
              '/edit/consent/final-notice-of-recommendation',
            ]);
            break;
          case MenuAction.ViewConsentC7P:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.allConsentsSk.consentSkC7P}/${this.nycId}/${this.iepFormSk}/${this.iepType}` +
              '/view/consent/final-notice-of-recommendation',
            ]);
            break;

          //  Outreaches
          case MenuAction.CreateSchoolPlacementRequest:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepFormSk}/${this.nycId}/${this.iepFormSk}` +
              '/add/outreach/school-placement-request',
            ]);
            break;
          case MenuAction.EditSchoolPlacementRequest:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepFormSk}/${this.nycId}/${this.iepFormSk}` +
              '/edit/outreach/school-placement-request',
            ]);
            break;
          case MenuAction.ViewSchoolPlacementRequest:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepFormSk}/${this.nycId}/${this.iepFormSk}` +
              '/view/outreach/school-placement-request',
            ]);
            break;
          case MenuAction.CreateStudentExitSummary:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepFormSk}/${this.nycId}/${this.iepFormSk}` +
              '/add/outreach/student-exit-summary',
            ]);
            break;
          case MenuAction.EditStudentExitSummary:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepFormSk}/${this.nycId}/${this.iepFormSk}` +
              '/edit/outreach/student-exit-summary',
            ]);
            break;
          case MenuAction.ViewStudentExitSummary:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepFormSk}/${this.nycId}/${this.iepFormSk}` +
              '/view/outreach/student-exit-summary',
            ]);
            break;
          case MenuAction.CreateAuthorizationToAttendLetter:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepFormSk}/${this.nycId}/${this.iepFormSk}` +
              '/add/outreach/authorization-to-attend-letter',
            ]);
            break;
          case MenuAction.EditAuthorizationToAttendLetter:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepFormSk}/${this.nycId}/${this.iepFormSk}` +
              '/edit/outreach/authorization-to-attend-letter',
            ]);
            break;
          case MenuAction.ViewAuthorizationToAttendLetter:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepFormSk}/${this.nycId}/${this.iepFormSk}` +
              '/view/outreach/authorization-to-attend-letter',
            ]);
            break;
          case MenuAction.CreateP1Package:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepFormSk}/${this.nycId}/${this.iepFormSk}` +
              '/add/outreach/p1-package',
            ]);
            break;
          case MenuAction.EditP1Package:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepFormSk}/${this.nycId}/${this.iepFormSk}` +
              '/edit/outreach/p1-package',
            ]);
            break;
          case MenuAction.ViewP1Package:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepFormSk}/${this.nycId}/${this.iepFormSk}` +
              '/view/outreach/p1-package',
            ]);
            break;
          case MenuAction.CreateAuthorizationIepNoChange:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepFormSk}/${this.nycId}/${this.iepFormSk}` +
              '/add/outreach/ar1p-no-change',
            ]);
            break;
          case MenuAction.EditAuthorizationIepNoChange:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepFormSk}/${this.nycId}/${this.iepFormSk}` +
              '/edit/outreach/ar1p-no-change',
            ]);
            break;
          case MenuAction.ViewAuthorizationIepNoChange:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepFormSk}/${this.nycId}/${this.iepFormSk}` +
              '/view/outreach/ar1p-no-change',
            ]);
            break;
          case MenuAction.CreateAuthorizationIepChange:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepFormSk}/${this.nycId}/${this.iepFormSk}` +
              '/add/outreach/ar2p-change',
            ]);
            break;
          case MenuAction.EditAuthorizationIepChange:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepFormSk}/${this.nycId}/${this.iepFormSk}` +
              '/edit/outreach/ar2p-change',
            ]);
            break;
          case MenuAction.ViewAuthorizationIepChange:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepFormSk}/${this.nycId}/${this.iepFormSk}` +
              '/view/outreach/ar2p-change',
            ]);
            break;
          case MenuAction.CreateFinalNoticeRecommendation:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepFormSk}/${this.nycId}/${this.iepFormSk}` +
              '/add/outreach/c8p-final-notice-of-recommendation',
            ]);
            break;
          case MenuAction.EditFinalNoticeRecommendation:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepFormSk}/${this.nycId}/${this.iepFormSk}` +
              '/edit/outreach/c8p-final-notice-of-recommendation',
            ]);
            break;
          case MenuAction.ViewFinalNoticeRecommendation:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepFormSk}/${this.nycId}/${this.iepFormSk}` +
              '/view/outreach/c8p-final-notice-of-recommendation',
            ]);
            break;
          case MenuAction.CreateParentWithdrawalOfConsent:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.nycId}/${this.iepFormSk}/${this.iepType}` +
              '/add/consent/parent-withdrawal-of-consent',
            ]);
            break;
          case MenuAction.EditParentWithdrawalOfConsent:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.allConsentsSk.parentWithdrawalSk}/${this.nycId}/${this.iepFormSk}/${this.iepType}` +
              '/edit/consent/parent-withdrawal-of-consent',
            ]);
            break;
          case MenuAction.ViewParentWithdrawalOfConsent:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.allConsentsSk.parentWithdrawalSk}/${this.nycId}/${this.iepFormSk}/${this.iepType}` +
              '/view/consent/parent-withdrawal-of-consent',
            ]);
            break;
          case MenuAction.CreateNoticeOfTermination:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.nycId}/${this.iepFormSk}/${this.iepType}` +
              '/add/consent/notice-of-termination',
            ]);
            break;
          case MenuAction.EditNoticeOfTermination:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.allConsentsSk.noticeOfTerminationSk}/${this.nycId}/${this.iepFormSk}/${this.iepType}` +
              '/edit/consent/notice-of-termination',
            ]);
            break;
          case MenuAction.ViewNoticeOfTermination:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.allConsentsSk.noticeOfTerminationSk}/${this.nycId}/${this.iepFormSk}/${this.iepType}` +
              '/view/consent/notice-of-termination',
            ]);
            break;

          case MenuAction.CreatePriorNoticePlacementWithdrawal:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepFormSk}/${this.nycId}/${this.iepFormSk}` +
              '/add/pwn/withdrawal-initial-referral-special-education-process',
            ]);
            break;
          case MenuAction.EditPriorNoticePlacementWithdrawal:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepFormSk}/${this.nycId}/${this.iepFormSk}/${this.allOutreachSk.placementWithdrawalSk}` +
              '/edit/pwn/withdrawal-initial-referral-special-education-process',
            ]);
            break;
          case MenuAction.ViewPriorNoticePlacementWithdrawal:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepFormSk}/${this.nycId}/${this.iepFormSk}/${this.allOutreachSk.placementWithdrawalSk}` +
              '/view/pwn/withdrawal-initial-referral-special-education-process',
            ]);
            break;
          case MenuAction.LaunchTenMonthPlacementFinder:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.nycId}/${this.iepFormSk}` +
              '/add/placement-finder',
            ]);
            break;

          case MenuAction.CaseClose:
            this.openCaseClosingEventsDialog();
            break;
        }

        break;

      case MenuAction.EventLog.toLowerCase():
        switch (menuItem.item.text) {
          case MenuAction.ViewUserEvent:
            this.action = viewAction;
            this.openStudentRelatedEventsDialog();
            break;
          case MenuAction.EditUserEvent:
            this.action = EDIT;
            this.openStudentRelatedEventsDialog();
            break;
          case MenuAction.DeleteUserEvent:
            this.action = DELETE_ACTION;
            this.openStudentRelatedEventsDialog();
            break;
        }
        break;

      case MenuAction.KIP.toLowerCase():
        switch (menuItem.item.text) {
          case MenuAction.CreateChildOutcomesSummary:
            this.router.navigate([
              this.routesConstantService.routes.kip +
              `/${this.nycId}` +
              '/add/child-outcomes-summary',
            ]);
            break;
          case MenuAction.EditChildOutcomesSummary:
            this.router.navigate([
              this.routesConstantService.routes.kip +
              `/${this.nycId}` +
              '/edit/child-outcomes-summary',
            ]);
            break;
          case MenuAction.ViewChildOutcomesSummary:
            this.router.navigate([
              this.routesConstantService.routes.kip +
              `/${this.nycId}` +
              '/view/child-outcomes-summary',
            ]);
            break;
        }
        break;
    }
  }

  getPwnUrl(pwnType: number): string {
    let pwnUrl: string = '';
    switch (pwnType) {
      case PwnType.RequestForReEval:
        pwnUrl = PWN_INFO.proposedRequestReevaluation.route;
        break;
      case PwnType.AdditionalReEval:
        pwnUrl = PWN_INFO.requestForAdditionalReevaluation.route;
        break;
      case PwnType.RefusalReEval:
        pwnUrl = PWN_INFO.refusalOfRequestForReevaluation.route;
        break;
      case PwnType.RefusalAdditionalReEval:
        pwnUrl = PWN_INFO.refusalOfRequestForAdditionalReevaluation.route;
        break;
      case PwnType.Mandated3YearReEval:
        pwnUrl = PWN_INFO.mandatedThreeYearReevaluation.route;
        break;
      case PwnType.ParentWaiverMandated3YearReEval:
        pwnUrl = PWN_INFO.parentWaiverMandatedThreeYearReevaluation.route;
        break;
      case PwnType.Initial:
        pwnUrl = PWN_INFO.initial.route;
        break;
      case PwnType.ReevaluationAnnual:
        pwnUrl = PWN_INFO.reevaluationAnnual.route;
        break;
    }
    return pwnUrl;
  }

  consentDependenciesExist(): boolean {
    return (
      this.expandedRowData
        // TODO: Not sure of the datatype. Define and use a proper datatype instead of any
        .map((data) => +data.document.eiDocumentType)
        .filter(
          (type: number) =>
            type === EI_FEEDING_ASSESSMENT ||
            type === EI_CONSENT_TRANSITION_CONFERENCE ||
            type === EI_VISION_SCREENING_ASSESSMENT
        ).length > FIRST_INDEX
    );
  }

  obtainInformationDependenciesExist(): boolean {
    return (
      this.expandedRowData
        // TODO: Not sure of the datatype. Define and use a proper datatype instead of any
        .map((data) => +data.document.eiDocumentType)
        .filter(
          (type: number) =>
            type === EI_CUSTOM_OBSERVATION_ASSESSMENT ||
            type === EI_PRESCHOOL_ACCEPTANCE_LETTER ||
            type === EI_CIPS
        ).length > FIRST_INDEX
    );
  }

  afterOnDestroy(): void {
    // afterOnDestroy
  }

  private contains(target: EventTarget): boolean {
    return (
      this.anchor?.nativeElement.contains(target) ||
      (this.popup ? this.popup.nativeElement.contains(target) : false)
    );
  }
}
